import api from './Api';

export async function getCheckoutAvailability() {
    const response = await api.get('/api/v1/storefront/checkout-availability', {timeout:10000});
    const data = response.data?.data;
    if (typeof data?.checkout_enabled !== 'boolean') throw new Error('Checkout availability is unavailable.');
    return data;
}
